import { required, email, sameAs, maxLength, minLength } from 'vuelidate/lib/validators'
import { UFS } from '@/globals/staticVars.js'
let crmUfs = []
for (let uf of UFS) {
  crmUfs.push({
    id: uf.name,
    name: uf.name
  })
}
const formData = {
  'user.name': {
    size: 7,
    type: 'text',
    name: 'user.name',
    label: 'Nome completo',
    placeholder: 'Digite seu nome completo',
    value: null
  },
  'displayName': {
    size: 5,
    type: 'text',
    name: 'displayName',
    label: 'Nome para exibição',
    placeholder: 'Nome a ser visualizado pelos pacientes',
    value: null
  },
  'user.cpf': {
    size: 4,
    type: 'text',
    name: 'user.cpf',
    label: 'CPF',
    placeholder: 'Digite seu CPF',
    mask: '###.###.###-##',
    value: null
  },
  'user.rg': {
    size: 4,
    type: 'text',
    name: 'user.rg',
    label: 'RG',
    placeholder: 'Digite seu RG',
    maxlength: 15,
    value: null
  },
  'user.gender': {
    size: 4,
    type: 'select',
    name: 'gender',
    label: 'Sexo',
    placeholder: 'Selecione',
    value: null,
    options: [
      {
        id: 'F',
        name: 'Feminino'
      },
      {
        id: 'M',
        name: 'Masculino'
      }
    ]
  },
  'user.email': {
    size: 6,
    type: 'text',
    name: 'user.email',
    label: 'E-mail',
    placeholder: 'Digite seu e-mail',
    value: null
  },
  'user.contactPhone': {
    size: 6,
    type: 'text',
    name: 'user.contactPhone',
    label: 'Telefone',
    mask: ['(##) ####-####', '(##) #####-####'],
    placeholder: 'Digite seu telefone',
    value: null
  },
  crm: {
    size: 3,
    type: 'text',
    mask: '################',
    name: 'crm',
    label: 'Número do CRM',
    placeholder: 'Digite o nº do seu CRM',
    value: null
  },
  crmRegional: {
    size: 3,
    type: 'select',
    name: 'crmRegional',
    label: 'Regional do CRM',
    options: crmUfs,
    placeholder: '',
    value: null
  },
  medicalSpecialty: {
    size: 6,
    type: 'select',
    name: 'medicalSpecialty',
    label: 'Título de especialista',
    placeholder: 'Selecione um título',
    required: true,
    value: '',
    options: []
  },
  isAmbEspecialization: {
    size: 6,
    type: 'radio',
    name: 'isAmbEspecialization',
    label: 'Possui título de especialização pela AMB?',
    value: null,
    radios: [
      {
        name: 'is_amb',
        label: 'Sim',
        value: true
      },
      {
        name: 'not_amb',
        label: 'Não',
        value: 'false'
      }
    ]
  },
  isAttendHealthInsurance: {
    size: 6,
    type: 'radio',
    name: 'isAttendHealthInsurance',
    label: 'Atende plano de saúde?',
    value: null,
    radios: [
      {
        name: 'is_plan',
        label: 'Sim',
        value: true
      },
      {
        name: 'not_plan',
        label: 'Não',
        value: 'false'
      }
    ]
  },
  'user.plainPassword.first': {
    size: 6,
    type: 'password',
    name: 'plainPassword.first',
    label: 'Digite uma senha',
    value: null,
    hideErrors: true,
    warnings: {
      minLength: 'Deve ter no mínimo 8 caracteres',
      pwValid: 'Deve possuir no mínimo um número e uma letra'
    },
    errors: {
      required: ' '
    }
  },
  'user.plainPassword.second': {
    size: 6,
    type: 'password',
    name: 'plainPassword.second',
    label: 'Repita a senha',
    value: null,
    errors: {
      samePassword: 'Senhas não conferem'
    }
  }
}

const requiredFields = [
  'user.name', 'user.cpf', 'user.rg', 'user.email', 'user.gender', 'crmRegional', 'crm', 'user.contactPhone', 'isAmbEspecialization', 'isAttendHealthInsurance', 'medicalSpecialty', 'user.plainPassword.first', 'user.plainPassword.second'
]
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}
validations['user.plainPassword.first'] = {
  value: {
    required,
    minLength: minLength(8),
    pwValid: function (value) {
      return this.fn_VALID_PASSWORD(value)
    }
  }
}
validations['user.plainPassword.second'] = {
  value: {
    required,
    samePassword: sameAs(function () {
      return this.formData['user.plainPassword.first'].value
    })
  }
}
validations['user.email'] = {
  value: {
    required,
    email
  }
}

validations['user.rg'] = {
  value: {
    required,
    maxLength: maxLength(15)
  }
}

export {formData, validations}
